import React, { Fragment } from "react";

import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";

const TermsPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  ClickHandler();
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title cp-page-title pt-120 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-center ">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Terms and Conditions</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-80 pb-75">
              <div className="row">
                <div className="col-lg-11">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      CONTRACT FORMATION AND OVERVIEW
                    </h2>
                    <p>
                      These Terms and Conditions govern the terms under which
                      you may access and use this website and the services
                      associated with it (together, the”Service”). By accessing,
                      registering with and using the Service, you agree to be
                      bound by the terms of the Terms and Conditions. If you do
                      not wish to be bound by the Terms and Conditions do not
                      access, register with or use the Service. The language of
                      these Terms and Conditions is English and all Services,
                      instructions and transactions carried out in connection
                      with it shall be in English.In these Terms and Conditions,
                      the terms “TigrisPay”, refer to TigrisPay.
                      <br />
                      <br />
                      Together with its employees, directors, affiliates,
                      successors and assigns, TigrisPay is a company registered
                      in England and Wales with its registered office at 25
                      Cabot Square, Canary Wharf, London E14 4QZ. MLR number:
                      XVML00000175568. FCA number: 647030. It is registered as a
                      Money Service Business and supervised by HM Revenue &
                      Customs under Money Laundering Regulations (MLR) number
                      12912153. It is regulated by the Financial Conduct
                      Authority as a payment institution with reference number
                      123456. The terms “you” and “your” refer to users of the
                      Service, whether in their capacity as senders, recipients,
                      or visitors to this website. These Terms and Conditions
                      are effective from the date you first access, register
                      for, or use our Service.
                      <br />
                      <br />
                      The Terms and Conditions may change from time to time, but
                      changes will only be effective from the date they are made
                      and will not change the terms on which you previously used
                      the Service.The Service was created to assist customers to
                      send money to their family and friends, and to receive
                      money from family and friends, around the world. For
                      security reasons, we recommend that you only send money
                      through the Service to people you know personally. You
                      must not use the Service to send money to strangers for
                      example sellers of goods and/or services, private or
                      retail.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">DEFINITIONS</h2>
                    <p>
                      In this Terms and Conditions:“Destination Country” means
                      the country in which the Recipient receives money through
                      the Service.“Payment Instrument” means a valid instrument
                      of payment such as a bank account, debit card or credit
                      card.“Payout Amount” means the amount paid out to the
                      Recipient, after any foreign exchange conversion.
                    </p>
                    <p>
                      “Recipient” means someone who receives money through the
                      Service.“Sender” means someone who uses the Service to
                      send money.
                      <br />
                      <br />
                      “Service Fee” means the fee plus any additional charges
                      applicable to each Transaction, in accordance with the
                      price list published on the Website and/or Application, or
                      the prices or rates that we communicate to you before we
                      issue a Confirmation, or as provided in these Terms and
                      Conditions.
                      <br />
                      <br />
                      “Service Provider” means a local bank, money exchange
                      house, or other third party service providers with whom
                      TigrisPay works in providing the Service.
                      <br />
                      <br />
                      “Transaction” means a specific instruction to send money
                      through the Service.
                      <br />
                      <br />
                      “Transaction Amount” means the amount of money that the
                      Sender wishes to send to the Recipient, excluding any
                      applicable fees and prior to any foreign exchange
                      conversion.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      COMMISSION & FEES
                    </h2>
                    <p>
                      You agree to pay our fees in connection with the use of
                      our Services. We will not process your transaction until
                      we have received the fees from you. We will let you know
                      the exact amount payable by you when you set up your
                      transaction order.Our Fee structure as set out on our
                      website form part of this agreement which may be subject
                      to change at any time. You agree and authorise us to
                      deduct our fees.
                    </p>
                  </div>

                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      CANCELLATION AND REFUNDS
                    </h2>

                    <ul className="privacy-details">
                      <li>
                        You have the statutory right to cancel your agreement
                        with us after you have submitted a Transaction. This
                        right of cancellation continues until fourteen days
                        after you have submitted the transaction, or until we
                        have completed the contract by paying the Payout Amount
                        to the Recipient, whichever is the earlier. If you
                        exercise your right to cancel under this clause, we may
                        make a cancellation charge.
                      </li>
                      <li>
                        If you wish to exercise your right to cancel under this
                        clause, you must submit a written request to us at 25
                        Cabot Square, Canary Wharf, London, England, E14 4QZ. or
                        send an email to hello@tigrispay.com, giving the Sender’s
                        full name, address, and phone number, together with the
                        Transaction tracking number, Transaction Amount, and the
                        reason for your refund request.
                      </li>
                      <li>
                        Any refunds will be credited back to the same Payment
                        Instrument used to fund the Transaction and in the same
                        currency. No adjustment will be made for any currency
                        fluctuations which may have occurred in the meanwhile.
                      </li>
                      <li>
                        If by the time you notify us of the cancellation of the
                        transfer we have already sent the money to one of our
                        partners in the country of destination, we may not be
                        able to successfully cancel the order, given that the
                        cancellation procedures with our partners differ in
                        length and complexity, as well as often require
                        communication across time zones.
                      </li>
                      <li>
                        We will not refund funds for transactions that are not
                        revocable and have been initiated.
                      </li>
                      <li>
                        Your order expires after 1 month. In case the money has
                        not been collected (in the case of cash transfers) or
                        the order requires a correction, we reserve the right to
                        cancel your order without prior notice to you and to
                        refund to you the amount that was to be transferred. The
                        refund will not include the Fees paid for the Service,
                        which we will retain.
                      </li>
                      <li>
                        Refunds can take up to 7 business days to be processed
                        and this depends as well on the customer’s bank and card
                        payment acquirers’ processes, which are beyond our
                        control.
                      </li>
                    </ul>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      CONTRACT FORMATION
                    </h2>
                    <p>
                      Upon placing a LTD Transaction via the Website or the
                      Application, an e-mail will be sent to you acknowledging
                      that your transaction has been received. Please note that
                      this does not mean that your transaction is accepted.A
                      transaction order constitutes solely an offer to buy our
                      services, which is subject to our discretionary
                      acceptance. Such acceptance will be communicated to you
                      via e-mail confirming that we are processing your request
                      (hereinafter called “the Confirmation”). The contract
                      between you and us (hereinafter called “the Contract”)
                      will only be formed when the Confirmation has been sent.
                      The Contract relates solely to the services that have been
                      confirmed accepted in the Confirmation. We reserve the
                      right to refuse to perform any of the Services (including
                      after Confirmation) if:
                    </p>

                    <ul className="privacy-details">
                      <li>
                        We are unable to obtain satisfactory evidence of your
                        identity.
                      </li>
                      <li>
                        You provide us with false, incorrect or incomplete
                        information.
                      </li>
                      <li>
                        We are unable to reach you via contact details provided
                        by you.
                      </li>
                      <li>
                        Your transfer order, information or documentation is not
                        provided sufficiently in advance to allow us to process
                        it in accordance to your request.
                      </li>
                      <li>
                        You attempt to tamper, hack, modify, overload, or
                        otherwise corrupt or circumvent the security and/or
                        functionality of the Website and/or the Application or
                        to infect it with any Malicious Code.
                      </li>
                      <li>You are in breach of these Terms and Conditions.</li>
                      <li>
                        You or the order you placed are in breach of any
                        applicable laws or regulations or are made for a
                        Prohibited Purpose.
                      </li>
                      <li>
                        Processing the Service in accordance with your order may
                        expose us to liability.
                      </li>
                      <li>
                        We are unable to process your transfer due to variations
                        in business hours, currency exchange or currency
                        availability issues.
                      </li>
                      <li>
                        We have reason to believe that any of the foregoing has
                        occurred or is likely to occur.
                      </li>
                      <li>
                        We have reason to believe that any of the foregoing has
                        occurred or is likely to occur.
                      </li>
                      <li>
                        An Officer has taken a discretionary decision to do
                        so.We shall not be liable for any damages, costs or
                        losses incurred by the Sender or the Recipient or any
                        third party if, as a result of any of the circumstances
                        referred to above.Email Confirmation: After we process
                        your transaction to the Recipient an e-mail will be sent
                        to you with the following information: A transaction
                        reference number, a confirmation of the exact amount we
                        are sending to the Recipient on your behalf in both pay
                        in and pay out currencies, a confirmation of the Fee
                        that has been charged and an exchange rate applied to
                        your transaction.OUR OBLIGATIONSSubject to these Terms
                        and Conditions, we agree to provide the Service to you
                        using reasonable care. The Service may not be available
                        in whole or in part in certain regions, countries, or
                        jurisdictions.We are not obliged to process any
                        particular Transaction. When you submit a Transaction,
                        you are requesting that we process the Transaction on
                        your behalf. We may, in our sole discretion, choose
                        whether or not to accept the offer to process that
                        Transaction. However, if we decide not to process the
                        Transaction, we will notify you promptly of that
                        decision and repay the money paid to us.TigrisPay
                        reserves the right to modify or discontinue the service
                        or any part of the Service without notice, at any time
                        and from time to time. We may, in our absolute
                        discretion, refuse any Transaction or limit the amount
                        to be transferred, either on a per transaction basis or
                        on an aggregate basis, and either on individual accounts
                        or on related accounts.We may, in our sole discretion,
                        refuse Transactions from certain Senders or to certain
                        Recipients, including but not limited to entities and
                        individuals on restricted or prohibited lists issued
                        from time to time by governments, regulatory bodies or
                        other authoritative sources. In addition, not all
                        Payment Instruments are available to all customers at
                        all times and we may, in our sole discretion, refuse
                        Transactions funded from certain Payment Instruments.We
                        will attempt to process Transactions promptly, but any
                        Transaction may be delayed or cancelled for a number of
                        reasons including but not limited to: our efforts to
                        verify your identity; to validate your Transaction
                        instructions; to contact you; or otherwise to comply
                        with applicable law; or due to variations in business
                        hours and currency availability.We will attempt to
                        provide Senders and Recipients with up to date
                        information regarding the location and opening hours of
                        our Service Providers by means of information on our
                        website. However, you agree that TigrisPay shall not be
                        held responsible for any inaccuracies that may appear in
                        that information or any consequential loss which may
                        result from incorrect or incomplete information. YOUR
                        OBLIGATIONSyou will not access, use or attempt to use
                        the Service as a Sender unless you are at least 18 years
                        old, and that you have the legal capacity to form a
                        binding legal contract in the relevant jurisdiction;For
                        each Transaction that you submit, you will pay us the
                        Service Fee in addition to the Transaction Amount.
                        Payment becomes due at the time that you submit your
                        Transaction. If you submit a Transaction that results in
                        TigrisPay becoming liable for charges including but not
                        limited to chargeback or other fees, you agree to
                        reimburse us for all such fees;In connection with your
                        registration and use of the Service, you will
                      </li>
                      <li>
                        provide us with true, accurate, current and complete
                        evidence of your identity, and promptly update your
                        personal information if and when it changes.
                      </li>
                      <li>
                        provide us with details of one or more Payment
                        Instruments.
                      </li>
                      <li>
                        provide us with true, accurate, current and complete
                        information for all Transactions.We do not accept any
                        liability for damages resulting from non-payment or
                        delay in payment of a LTD to a Recipient or failure to
                        perform a transaction under the Service by reason of any
                        of these matters.
                      </li>
                      <li>
                        when you pay for a Transaction in one currency and the
                        Recipient is paid in another currency, there will be a
                        difference between the exchange rate at which we buy
                        foreign currency and the exchange rate provided to you.
                        TigrisPay and its Service Providers usually make a small
                        profit in these circumstances. If such account is
                        denominated in another currency the amount to be
                        received by the Recipient will be reduced by the amount
                        of extra charges incurred by reason of the incorrect
                        information given by you and we will have no obligation
                        to make good such reduction.
                      </li>
                      <li>
                        when you are sending money under these Terms and
                        Conditions, it is your responsibility to make sure all
                        the Transaction details are accurate before submission.
                        Once a Transaction has been submitted for processing it
                        is not normally possible to change any of its details.
                        You will be given the opportunity to confirm
                        Transactions before submission and you must check the
                        details carefully.
                      </li>
                      <li>
                        TigrisPay will have no responsibility for any fees or
                        charges you may incur by the use of a particular Payment
                        Instrument to fund a Transaction. These may include but
                        are not limited to unauthorised overdraft fees imposed
                        by banks if there are insufficient funds in your bank
                        account or “cash advance” fees and additional interest
                        which may be imposed by credit card providers if they
                        treat use of the Service as a cash transaction rather
                        than a purchase transaction.
                      </li>

                      <li>
                        You will only use the Service to send money to people
                        that you know personally and not to pay for goods or
                        services. If, in breach of this clause, you choose to
                        pay third parties for goods and services using the
                        Service, you acknowledge that TigrisPay has no control
                        over, and is not responsible for, the quality, safety,
                        legality, or delivery of such goods or services and that
                        any such use of the Service is entirely at your own
                        risk. If TigrisPay reasonably believes you are using the
                        Service to purchase goods or services, we reserve the
                        right to cancel your Transaction(s)
                      </li>
                      <li>
                        Both you and the Recipients will only act on your own
                        behalf. You may not submit or receive a Transaction on
                        behalf of a third person. If you intend to submit or
                        receive a Transaction on behalf of a company, business
                        or any entity other than a human individual, you must
                        first inform TigrisPay of your desire to do so and
                        provide us with any additional information about the
                        entity we may request in order that we may decide
                        whether to permit the Transaction
                      </li>
                      <li>
                        In using the Service you will comply with these Terms
                        and Conditions as well as any applicable laws, rules or
                        regulations. It is a breach of these Terms and
                        Conditions to use the Service to send money (i) to a
                        Recipient who has violated the Terms and Conditions, or
                        (ii) in connection with illegal activity including
                        without limitation money-laundering, fraud and the
                        funding of terrorist organisations. If you use the
                        Service in connection with illegal activity, TigrisPay
                        may report you to the appropriate legal authorities.
                      </li>
                      <li>
                        when using our website or the Service or when
                        interacting with TigrisPay, with another user or with a
                        third party, you will not: Breach this Terms and
                        Conditions, or any other agreement between you and
                        TigrisPay; Open more than one account, without our prior
                        written permission; Provide false, inaccurate, or
                        misleading information; Allow anyone else access to your
                        registration details, and will keep those details
                        secure; refuse to provide confirmation of any
                        information you provide to us, including proof of
                        identity, or refuse to co-operate in any investigation;
                        use an anonymising proxy (a tool that attempts to make
                        activity untraceable); or copy or monitor our website
                        using any robot, spider, or other automatic device or
                        manual process, without our prior written permission.
                      </li>
                      <li>
                        TigrisPay may, as necessary in providing the Service,
                        store all information required of a Recipient to prove
                        his or her identity or associated with their specific
                        Transaction. Such proofs may include a suitable form of
                        valid, unexpired identification from a list of
                        acceptable papers provided by the Service Provider,
                        and/or a Transaction tracking number, a personal
                        identification number (PIN), a “password”, a “secret
                        word”, or other similar identifiers.
                      </li>
                    </ul>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Collection Of Information Customer Identification Program
                    </h2>
                    <p>
                      English law requires all financial institutions to assist
                      in the fight against money laundering activities and the
                      funding of terrorism by obtaining, verifying, and
                      recording identifying information about all customers. We
                      may therefore require you to supply us with personal
                      identifying information and we may also legally consult
                      other sources to obtain information about you.Verification
                      and Checks. We will verify your residential address and
                      personal details in order to confirm your identity. We may
                      also pass your personal information to a credit reference
                      agency, which may keep a record of that information. You
                      can be rest assured that this is done only to confirm your
                      identity, that a credit check is not performed and that
                      your credit rating will be unaffected. All information
                      provided by you will be treated securely and strictly in
                      accordance with the General Data Protection Regulation.By
                      accepting these Terms and Conditions you authorise us to
                      make any inquiries we consider necessary to validate the
                      information that you provide to us. We may do this
                      directly, for example by asking you for additional
                      information, requiring you to take steps to confirm
                      ownership of your Payment Instruments or email address; or
                      by verifying your information against third party
                      databases; or through other sources.Data Privacy Policy.
                      You consent to our processing your personal information
                      for the purposes of providing the Service, including for
                      verification purposes as set out in this clause. You also
                      consent to the use of such data for communicating with
                      you, and for statutory, accounting and archival purposes.
                      You acknowledge that you have read and consented to
                      TigrisPay’s Privacy Policy. The Privacy Policy can be
                      found on our web site: www.alphandomega.comGovernment
                      Disclosures. We may be required by law to provide
                      information about you and your Transactions to government
                      or other competent authorities as described in our Privacy
                      Policy. You acknowledge and consent to our doing this.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      INTELLECTUAL PROPERTY TigrisPay website and the TigrisPay
                      Service
                    </h2>
                    <p>
                      The content, and all intellectual property relating to
                      them and contained in them (including but not limited to
                      copyrights, patents, database rights, trademarks and
                      service marks) are owned by us, our affiliates, or third
                      parties. All right, title and interest in and to the
                      TigrisPay Online Site and the TigrisPay Online Service
                      shall remain our property and/or the property of such
                      other third parties.You may use the Website and the
                      Application only for the purpose of the bona fide use of
                      our Services as an individual consumer or business
                      customer and only as permitted by these Terms and
                      Conditions or described on the Website. You are authorized
                      solely to view and to retain a copy of the pages of the
                      Website for your own personal use. The Website and the
                      Application and the Services may not be used for the
                      purpose of testing the Service or to obtain information
                      about the Service or about us. You may not duplicate,
                      publish, modify, create derivative works from, participate
                      in the transfer or sale of, post on the internet, or in
                      any way distribute or exploit the Website, the Application
                      or any portion thereof for any public or commercial use
                      without our express written permission. You may not: (a)
                      use any robot, spider, scraper or other automated device
                      to access the Website or the Application or to use the
                      Service; and/or (b) remove or alter any copyright, trade
                      mark or other proprietary notice or legend displayed on
                      the Website (or printed pages of the Website).
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Play Console App Notice
                    </h2>
                    <p>
                      Fast Track Money Transfer Limited (trading as TigrisPay)
                      is a company registered in England & Wales (Company No.
                      06872129) and is authorised and regulated by the Financial
                      Conduct Authority (FRN: 647030) as an Authorised Payment
                      Institution for the provision of money remittance
                      services. The TigrisPay mobile application is currently
                      published on Google Play under the developer account of
                      Calyx Solutions UK Ltd, pursuant to a temporary technical
                      hosting arrangement between both parties. This arrangement
                      is limited solely to app hosting and does not involve any
                      transfer of ownership, licensing, or regulatory
                      responsibility. All customer relationships, operational
                      controls, and compliance obligations remain solely with
                      Fast Track Money Transfer Limited (TigrisPay).
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      WARRANTIES AND LIABILITY
                    </h2>
                    <p>
                      We will refund to you any benefit which we receive as a
                      result of any breach of our agreement with you (this means
                      that, for example, where a LTD has failed in such
                      circumstances we will refund to you the Transaction Amount
                      and the Service Fee). If a LTD is delayed or fails, you may
                      have a right to receive a refund or compensation under
                      laws relating to the provision of international LTD
                      services. We will provide you with the details of your
                      rights to a refund or compensation if you contact us using
                      the contact details at the end of this agreement.Any claim
                      for compensation made by you and/or a Recipient (who is
                      not registered with us) must be supported by any available
                      relevant documentation. If any loss which you or a
                      Recipient (who is not registered with us) suffers is not
                      covered by a right to payment under the laws referred to
                      in clause 8.2, we will only accept liability for that loss
                      up to a limit which is the greater of: (a) the amount of
                      any service charge; and (b) £250, unless otherwise agreed
                      by us in writing. Our cap on our liability only limits a
                      claim for loss arising out of any single transaction or
                      related transactions, or (if a loss does not arise out of
                      a transaction or transactions) any single act, omission or
                      event or related acts, omissions or events. We do not, in
                      any event, accept responsibility for: 
                    </p>
                  </div>

                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">COMPLAINTS</h2>
                    <p>
                      We value your feedback as it helps us improve our service.
                      We have established internal procedures for complaints.
                      You can make a complaint in writing to us regarding any
                      aspect of the Service by mail or e-mail to the following
                      addresses: 25 Cabot Square, Canary Wharf, London, England,
                      E14 4QZ. Email: hello@tigrispay.com <br></br>We will
                      investigate your complaint and use reasonable endeavours
                      to come back to you with the results of our investigation
                      within 7 working days after receipt of your complaint. If
                      you are still dissatisfied with the manner in which we
                      have dealt with your complaint or the outcome of it, you
                      have a right to refer your complaint to the Financial
                      Ombudsman Service, South Quay Plaza, 183 Marsh Wall,
                      London E14 9SR, Tel No 0800 0234 567, Email:
                      <a href="mailto:complaint.info@financial-ombudsman.org.uk">
                        complaint.info@financial-ombudsman.org.uk
                      </a>
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Governing law</h2>
                    <p>
                      The Payment Services Regulations 2009 (SI 2009/209)
                      (hereinafter called “the Regulations”) govern the transfer
                      of money to recipients within the European Economic Area
                      (being all members states of the European Union, together
                      with Norway, Iceland and Liechtenstein), where the
                      transfer of funds is carried out in Euros, Sterling or the
                      currency of another EEA state which has not adopted the
                      Euro as its currency. The Regulations regulate payment
                      services, which have an electronic component and place
                      payment services providers into certain categories as well
                      as require certain payment institutions to be authorised
                      by the FCA and to follow conduct of business rules. As per
                      laws of England and wales TigrisPay is trading name of
                      Fast Track Money Transfer Limited Registered at 25 Cabot
                      Square, Canary Wharf, London, E14 4QZ with Company
                      Registration No. 06872129. FCA registration number 647030.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">No Waiver</h2>
                    <p>
                      The failure of TigrisPay to exercise or enforce any right
                      or provision of the Terms and Conditions shall not
                      constitute a waiver of such right or provision.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Modification</h2>
                    <p>
                      We may modify this Terms and Conditions from time to time
                      without notice to you, except as may be required by law.
                      You can review the most current version of the Terms and
                      Conditions at any time by reviewing this website. You may
                      terminate your use of the Service if you do not agree with
                      any modification or amendment. If you use the Service
                      after the effective date of an amendment or modification,
                      you shall be deemed to have accepted that amendment or
                      modification. You agree that you shall not modify this
                      Terms and Conditions and acknowledge that any attempts by
                      you to modify this Terms and Conditions shall be void.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Severability</h2>
                    <p>
                      If any provision of the Terms and Conditions is found by
                      an arbitrator or court of competent jurisdiction to be
                      invalid, the parties nevertheless agree that the
                      arbitrator or court should endeavour to give appropriately
                      valid effect to the intention of the Terms and Conditions
                      as reflected in the provision, and the other provisions of
                      the Terms and Conditions shall remain in full force and
                      effect. Any external links to third-party websites on the
                      website are provided as a convenience to you. These sites
                      are not controlled by us in any way and we are not
                      responsible for the accuracy, completeness, legality or
                      any other aspect of these other sites including any
                      content provided on them. You access such websites at your
                      own risk.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">SECURITY</h2>
                    <p>
                      We take security very seriously at TigrisPay, and we work
                      hard, using state-of-the-art security measures, to make
                      sure that your information remains secure. TigrisPay
                      Service is a safe and convenient way to send money to
                      friends and family and to other people that you trust.
                      However, we do advise you to consider very carefully
                      before sending money to anyone that you do not know well.
                      In particular, you should be very cautious of deals or
                      offers that seem too good to be true – they may be scams.
                      If you are aware of anyone or any entity that is using the
                      Service inappropriately, please email us using
                      hello@tigrispay.com. Similarly, if you receive any emails,
                      purporting to be from TigrisPay, which you suspect may be
                      “phishing” (fake) emails, please forward them to us using
                      at <a href="mailto:hello@tigrispay.com">hello@tigrispay.com</a>
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      CONTACT INFORMATION
                    </h2>
                    <p>
                      Questions, notices, and requests for refunds or further{" "}
                      <br />
                      information should be sent to TigrisPay, as follows:
                      <br />
                      Email:<a href="mailto:hello@tigrispay.com">
                        hello@tigrispay.com{" "}
                      </a>{" "}
                      Telephone:{" "}
                      <a href="tel:+4402030055883">+44 02030055883 </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClassNamclassName={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TermsPage;
